import "./style/index.css";
import React from "react";
import { Input } from "antd";
import trim from "lodash/trim";
import classNames from "classnames";
import WeaTools from "../../wea-tools";
import isRegExp from "lodash/isRegExp";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";

class Main extends React.Component {
  static defaultProps = {
    style: {},
    viewAttr: 2,
    disabled: false,
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : "",
      minRows: props.minRows || 2,
      maxRows: props.maxRows
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if (nextProps.minRows && nextProps.minRows !== this.state.minRows) {
      this.setState({ minRows: nextProps.minRows });
    }
    if (nextProps.maxRows && nextProps.maxRows !== this.state.maxRows) {
      this.setState({ maxRows: nextProps.maxRows });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value !== this.props.value ||
      nextProps.viewAttr !== this.props.viewAttr ||
      this.state.value !== nextState.value ||
      nextProps.minRows !== this.state.minRows ||
      nextProps.maxRows !== this.state.maxRows
    );
  }
  onClick(e, value) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick && this.props.onClick(e.target.value);
    if (value && (!!window.ActiveXObject || "ActiveXObject" in window)) {
      // 处理ie下右键粘贴到文本框没有触发onchange问题
      isFunction(this.props.onChange) && this.props.onChange(value);
    }
  }
  setCursorInEnd(input) {
    // 火狐下阻止事件会导致光标丢失
    // e.preventDefault();
    // e.stopPropagation();
    // 处理ie下光标出现在文本最前面
    // const input = e.target;
    const selectionStart = input.value.length;
    const selectionEnd = input.value.length;
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd("character", selectionEnd);
      range.moveStart("character", selectionStart);
      range.select();
    }
  }
  onFocus(e) {
    this.props.onFocus &&
      this.props.onFocus(e.target.value.replace(/\u200B/g, ""));
  }
  onBlur(e) {
    const { props } = this;
    let value = e.target.value.replace(/\u200B/g, "");
    if (props.filter) {
      value = props.filter(value);
      if (e.target.value !== value) {
        this.setState({ value }, () => {
          props.onChange && props.onChange(value);
        });
      }
    }
    props.onBlur && props.onBlur(value);
  }
  setValue(v = "") {
    let { value } = this.state;
    const dom = this.refs.input.refs.input;
    dom.focus();
    value =
      dom.value.substr(0, dom.selectionStart) +
      v +
      dom.value.substring(dom.selectionStart, dom.value.length);
    this.setState({ value }, () => dom.focus());
    this.props.onChange && this.props.onChange(value);
  }
  onChange(e) {
    const { props } = this;
    let value = e.target.value.replace(/\u200B/g, "");
    if (this.props.length && value.length > this.props.length) {
      value = value.substring(0, this.props.length);
    }
    if (
      this.props.stringLength &&
      WeaTools.getStringLength(value) > this.props.stringLength
    ) {
      value = WeaTools.getStringByLength(value, this.props.stringLength);
    }
    if (
      !isEmpty(value) &&
      props.regExp &&
      isRegExp(props.regExp) &&
      !props.regExp.test(value)
    ) {
      value = this.state.value || "";
    }
    this.setState({
      value
    });
    this.props.onChange && this.props.onChange(value);
  }
  focus = () => {
    const input = this.refs.input.refs.input;
    input && input.focus && input.focus();
  };
  render() {
    const props = this.props;
    let { value, minRows, maxRows } = this.state;
    const {
      viewAttr,
      fieldName,
      style,
      ecId,
      disabled,
      textDecoration,
      placeholder,
      noResize,
      textareaStyle,
      className
    } = props;
    let styleInfo = {
      // "word-break": "break-all",
      "word-wrap": "break-word",
      width: "100%",
      ...textareaStyle
    };
    if (noResize) {
      styleInfo["resize"] = "none";
    }
    const req = classNames({
      [`${className}`]: className,
      required: viewAttr == "3" && trim(value).length === 0
    });
    if (viewAttr == 1) {
      // 解决&lt; &gt; 转义字符显示问题，transHTML方法中同时处理
      let _value = value;
      // 带标签情况
      if (/<[^>]+>/g.test(_value)) {
        _value = WeaTools.transHTML(_value);
        return (
          <span
            className={`wea-textarea-normal wea-field-readonly ${className}`}
            style={style}
            id={fieldName}
            dangerouslySetInnerHTML={{ __html: _value }}
          />
        );
      }
      // 只是纯文本情况, 不走dangerouslySetInnerHTML （例如：&times 会解析成 x）
      return (
        <span
          className={`wea-textarea-normal wea-field-readonly ${className}`}
          style={style}
          id={fieldName}
        >
          {_value}
        </span>
      );
    }
    return (
      <div className={`wea-textarea-normal ${req}`} style={style}>
        <Input
          {...props}
          ecId={`${ecId}_Input@wx8le5`}
          ref="input"
          type="textarea"
          disabled={disabled}
          autosize={{ minRows: minRows, maxRows: maxRows }}
          value={value}
          id={fieldName}
          name={fieldName}
          style={styleInfo}
          className={`${textDecoration && "text-decoration"}`}
          onClick={this.onClick.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onChange={this.onChange.bind(this)}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-textarea-normal/index.js